<template>
  <div class="pop">
    <div class="pop-content" style="padding:10px 20px;">
      <div style="text-align: right;">
        <el-button type="info" class="btn-close" icon="el-icon-close" circle @click="bindClose"></el-button>
      </div>
      <div class="pop-content-title">{{payType[info.channel]}}</div>
      <div class="qrcode" ref="qrCodeUrl">
      </div>
      <div class="label">支付金额：￥{{info.amount}}</div>
      <div class="label">订单号：{{info.orderId || info.id}}</div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  props: ["info"],
  data () {
    return {
      payType: { 1: '微信支付', 2: '支付宝支付' },
    }
  },
  mounted () {
    this.$nextTick(() => {
      new QRCode(this.$refs.qrCodeUrl, {
        text: this.info.paymentCode, // 需要转换为二维码的内容
        width: 300,
        height: 300,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
    })
  },
  methods: {
    bindClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.pop {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #00000080;
  z-index: 9999;
  display: flex;
  align-items: center;
  .pop-content-title {
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    font-weight: bold;
  }
  .label {
    height: 30px;
    line-height: 30px;
  }
  .pop-content {
    margin: 0px auto;
    background-color: #fff; //设置白色背景色
    padding: 14px;
    border-radius: 4px;
  }
  .qrcode {
    display: inline-block;
    margin: 0px auto;
    img {
      width: 400px;
      height: 400px;
      background-color: #fff; //设置白色背景色
      padding: 6px; // 利用padding的特性，挤出白边
      box-sizing: border-box;
    }
  }
}
</style>